<template>
  <v-flex xs12>
      <v-container grid-list-lg>
          <v-layout row wrap>
                <v-flex xs12>
                  <h4 class="primary--text">Tipo de Seguro desejado</h4>
                  <v-flex xs12 sm4 class="pl-0 pb-0">
                    <v-text-field label="Tipo de Seguro" :value="model.tipoSeguro" disabled></v-text-field>
                  </v-flex>
              </v-flex>
              <v-flex xs12 v-if="model.taxaDesejada != null">
                  <h4 class="primary--text">Taxa desejada no Novo Seguro de Acidente</h4>
                  <template>
                      <v-flex xs12 sm4 class="pl-0 pb-0">
                          <v-text-field label="Taxa" :value="toPercentTaxaString(model.taxaDesejada)" disabled></v-text-field>
                      </v-flex>
                      <v-flex sm8 v-if="!$vuetify.breakpoint.xsOnly" class="pb-0"></v-flex>
                  </template>
              </v-flex>
              <v-flex xs12 v-else-if="model.descontoDesejado != 0">
                  <h4 class="primary--text">Desconto desejado no Novo Seguro de Acidente</h4>
                  <template>
                      <v-flex xs12 sm4 class="pl-0 pb-0">
                          <v-text-field label="Desconto" :value="toPercentString(model.descontoDesejado)" disabled></v-text-field>
                      </v-flex>
                      <v-flex sm8 v-if="!$vuetify.breakpoint.xsOnly" class="pb-0"></v-flex>
                  </template>
              </v-flex>
              <v-flex xs12 v-if="model.tipoSeguro == 'Acidente e Roubo'">
                  <h4 class="primary--text">Valor da taxa desejada no Novo Seguro de Roubo</h4>
              </v-flex>
              <v-flex xs12 v-if="model.tipoSeguro == 'Acidente e Roubo'">
                  <template>
                      <v-flex xs12 sm4 class="pl-0 pb-0">
                          <v-text-field label="Taxa" :value="toPercentTaxaString(model.taxaCoberturaRoubo)" disabled></v-text-field>
                      </v-flex>
                      <v-flex sm8 v-if="!$vuetify.breakpoint.xsOnly" class="pb-0"></v-flex>
                  </template>
              </v-flex>
              <v-flex xs12 sm4 class="pt-0">
                  <h4 class="primary--text">Início da vigência</h4>
                  <br>
                  <v-text-field label="Data de Início da Vigência" 
                      prepend-icon="event"
                      :value="toLocaleDateString(model.dataInicioVigencia)"
                      disabled></v-text-field>
              </v-flex>
              <v-flex sm8 v-if="!$vuetify.breakpoint.xsOnly"></v-flex>
              <v-flex xs12>
                  <h4 class="primary--text">Contato para averbação do novo seguro</h4>
              </v-flex>
              <v-flex xs12 sm6>
                  <v-text-field label="Nome" :value="model.contatos[0].nome" disabled></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="!$vuetify.breakpoint.xsOnly"></v-flex>
              <v-flex xs12 sm6>
                  <v-text-field label="E-mail" :value="model.contatos[0].email" disabled></v-text-field>
              </v-flex>
              <v-flex xs4 sm2>
                  <v-text-field label="DDD" :value="model.contatos[0].ddd" disabled></v-text-field>
              </v-flex>
              <v-flex xs8 sm4>
                  <v-text-field label="Telefone" :value="model.contatos[0].telefone" disabled></v-text-field>
              </v-flex>
              <v-flex xs12>
                  <h4 class="primary--text">Expectativa para cotação:</h4>
              </v-flex>
              <v-flex sm8 v-if="!$vuetify.breakpoint.xsOnly"></v-flex>
              <v-flex xs12>
                  <v-textarea
                  label="Conte-nos mais sobre sua expectativa para essa cotação"
                  disabled
                  readonly
                  :value="model.expectativa"></v-textarea>
              </v-flex>
          </v-layout>
      </v-container>
  </v-flex>
</template>

<script>
import CustomFormat from '@/helpers/custom-format'

export default {
  name: 'novoseguro',
  props: ['model'],
  methods: {
    toPercentString: function (val) {
        return CustomFormat.toPercentString(val);
    },
    toPercentTaxaString: function (val) {
        return CustomFormat.toPercentTaxaString(val);
    },
    toLocaleDateString: function (val) {
        return CustomFormat.toLocaleDateString(val);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/solicitacao-consulta/NovoSeguro.vue